import React from 'react';

const ArrowDown = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M23.4 9.5c-.5-.5-1.4-.5-2 .1l-8 9v-17c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4v17.1l-8-9.1C2 9 1.2 8.9.6 9.5c-.3.3-.4.7-.4 1.1 0 .3.1.6.2.8l10.5 12c.1.1.2.1.3.2l.1.1c.2.1.4.2.6.2h.2c.2 0 .3 0 .5-.1.1 0 .2-.1.3-.2.1-.1.2-.2.2-.3l10.4-11.8c.5-.6.5-1.4-.1-2z"></path>
  </svg>
);

export default ArrowDown;
